import { useEffect } from "react";
import type { ReactNode } from "react";
import { Container } from "@mui/material";
import { useNavigate } from "react-router";

/**
 * Page appelée après déconnexion de l'utilisateur sur la platefome Microsoft Online
 */
function FlushPage(): ReactNode {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
  }, [navigate]);

  return <Container maxWidth="md">Vous êtes à présent déconnecté.</Container>;
}

export default FlushPage;
